// The world cut into square chunks: the unit the streamer loads (meshes on the view tier; colliders, nav tiles and the
// `world:chunk` event on the sim tier). Ids are "i:j", i along x and j along z from the bounds' corner.
import type { Layout } from "./layout";

/** A rectangle on the ground plane (m): the same shape as `@rpg/stream`'s `Area`. */
export interface Area {
  x0: number;
  x1: number;
  z0: number;
  z1: number;
}

/** One chunk. */
export interface WorldChunk {
  id: string;
  i: number;
  j: number;
  area: Area;
  /** Its centre on the ground plane. */
  cx: number;
  cz: number;
}

/** The chunk id of grid cell (i, j). */
export const chunkId = (i: number, j: number): string => `${i}:${j}`;

/** Every chunk of a layout, row by row (j, then i). */
export function chunkGrid(layout: Layout): WorldChunk[] {
  const b = layout.bounds;
  const n = Math.round((b.x1 - b.x0) / layout.chunk);
  const m = Math.round((b.z1 - b.z0) / layout.chunk);
  const out: WorldChunk[] = [];
  for (let j = 0; j < m; j++)
    for (let i = 0; i < n; i++) {
      const x0 = b.x0 + i * layout.chunk;
      const z0 = b.z0 + j * layout.chunk;
      out.push({ id: chunkId(i, j), i, j, area: { x0, x1: x0 + layout.chunk, z0, z1: z0 + layout.chunk }, cx: x0 + layout.chunk / 2, cz: z0 + layout.chunk / 2 });
    }
  return out;
}
